import React from 'react'
import { UploadStep } from './UploadStep'
import { PreviewStep } from './PreviewStep'
import { useBulkStatusUpload } from './useBulkStatusUpload'

/**
 * Bulk Update Payment Assignment Status.
 *
 * Flow: upload (CSV or manual rows) -> preview/edit -> submit in batches.
 * All state and submit logic live in `useBulkStatusUpload`; this component
 * just wires that hook's output into the two step components.
 */
export default function PaymentAssignmentBulkStatusUpload() {
  const {
    fileInputRef,
    step,
    period,
    rows,
    parseError,
    rowErrors,
    submitLog,
    isSubmitting,
    isCancelling,
    batchProgress,
    validCount,
    invalidCount,
    setPeriod,
    handleDownloadTemplate,
    handleFileChange,
    handleAddRow,
    handleDeleteRow,
    handleAddManually,
    handleReset,
    handleConfirm,
    handleCancelSubmit,
    setRowField,
    setRowDynamicField,
  } = useBulkStatusUpload()

  if (step === 'upload') {
    return (
      <UploadStep
        period={period}
        parseError={parseError}
        fileInputRef={fileInputRef}
        onPeriodChange={setPeriod}
        onDownloadTemplate={handleDownloadTemplate}
        onFileChange={handleFileChange}
        onAddManually={handleAddManually}
      />
    )
  }

  return (
    <PreviewStep
      rows={rows}
      period={period}
      validCount={validCount}
      invalidCount={invalidCount}
      isSubmitting={isSubmitting}
      isCancelling={isCancelling}
      batchProgress={batchProgress}
      rowErrors={rowErrors}
      submitLog={submitLog}
      onAddRow={handleAddRow}
      onDeleteRow={handleDeleteRow}
      onBenefitIdChange={(key, v) => setRowField(key, { benefitId: v })}
      onStatusChange={(key, v) => setRowField(key, { status: v })}
      onNoteChange={(key, v) => setRowField(key, { note: v })}
      onFieldChange={setRowDynamicField}
      onConfirm={handleConfirm}
      onReset={handleReset}
      onCancel={handleCancelSubmit}
    />
  )
}
